<template>
  <Popover ref="popover" :showHeader="true" headerTitle="Map Legend" sizeClass="popover-medium">
    <div class="legend-content">
      <h4>Map Markers</h4>
      <small class="legend-subtitle">Numbers show the count of orders / tasks</small>

      <div class="pl-1">
        <div class="legend-line">
          <div class="legend-icon"><img src="/glass/img/tasks/legend_unassigned.png" /></div>
          <div class="legend-text">All Order(s) are unassigned</div>
        </div>
        <div class="legend-line">
          <div class="legend-icon"><img src="/glass/img/tasks/legend_partial.png" /></div>
          <div class="legend-text">Some orders are assigned, some unassigned</div>
        </div>
        <div class="legend-line">
          <div class="legend-icon"><img src="/glass/img/tasks/legend_assigned.png" /></div>
          <div class="legend-text">All orders/tasks are assigned to a single task with matching colour</div>
        </div>
        <div class="legend-line">
          <div class="legend-icon"><img src="/glass/img/tasks/legend_assigned_multiple.png" /></div>
          <div class="legend-text">All orders/tasks are assigned, but to multiple tasks</div>
        </div>
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.legend-content {
  padding: 0.5rem;
}
.legend-content > h4 {
  margin-top: 0;
  margin-bottom: -0.25rem;
}
.legend-line {
  clear: both;
  font-size: 13px;
  padding-top: 6px;
}
.legend-line > .legend-icon {
  float: left;
  width: 35px;    
}
.legend-line > .legend-text {
  float: left;
  width: calc(100% - 35px);
}
</style>


<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'MapLegendPopover',
  components: {
    Popover
  },
  methods: {
    displayFromElement(element) {
      this.$refs.popover.displayFromElement(element)
    },
  }
}
</script>
